import { find, flatMap, includes, isEmpty } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../constant';
import StepProgressBar from '../components/StepProgressBar';
import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import moment from 'moment';
import FileStatus from './FileStatus';
import { LoginContext } from '../context/logincontext';


export default function DealerLoanDetails() {
    const location = useLocation();
    const params = useParams()
    const context = useContext(LoginContext)
    const dealer = context?.user?.company
    const accessLevel = dealer?.evcred_access || []
    const allowedToUpload = includes(accessLevel, 'Pdd Upload')

    const [loanDetails, setloanDetails] = useState({});
    const [dealerPaymentDetails, setDealerPaymentDetails] = useState([]);
    const [dealerHoldAmount, setdDealerHoldAmount] = useState({});
    const [loanDeviation, setLoanDeviation] = useState([])
    const [loanDoc, setLoanDocs] = useState([])

    const [rank, setRank] = useState(0);


    const loanId = params?.loan_id;
    const dealerId = params?.dealer_id;

    useEffect(() => {
        if (dealerId && loanId) {
            loanOverview()
            dealerPaymentStatus();
        }
    }, [dealerId, loanId]);

    const loanOverview = async () => {
        const result = await axios.get(`${API_URL}/dealers/${dealerId}/loans/${loanId}`);
        const loanOverview = result?.data?.data;
        if (!isEmpty(loanOverview)) {
            setloanDetails(loanOverview[0])
            setRank(getRankFromLoanState(loanOverview[0].event))
            await fetchPddDetails(loanOverview[0].customer_id)
        }
    };

    const dealerPaymentStatus = async () => {
        const result = await axios.get(`${API_URL}/dealer/${dealerId}/loan/${loanId}/dealer_payment_details`);
        const dealerPayment = result?.data?.data;
        if (!isEmpty(dealerPayment)) {
            const rcSecurotyHold = find(dealerPayment, { loan_ledger_type: 'rc security hold' });
            const dealerPaymentDetails = dealerPayment.filter(payment => payment.loan_ledger_type === 'dealer payment');
            setDealerPaymentDetails(dealerPaymentDetails);
            setdDealerHoldAmount(rcSecurotyHold);
        }
    };

    const fetchPddDetails = async (customerId) => {
        const result = await axios.get(`${API_URL}/customer/${customerId}/loan/${loanId}/deviation`);
        const loanDeviations = result?.data?.data || [];

        if (!isEmpty(loanDeviations)) {
            setLoanDeviation(loanDeviations);

            const pddDoc = loanDeviations.map(d => d.doc_type).filter(Boolean);
            await getLoanDocsByDocType(pddDoc, loanDeviations);
        }
    }


    const getLoanDocsByDocType = async (pddDoc, loanDeviations) => {
        const result = await axios.get(`${API_URL}/loan/${loanId}/documents?type=${pddDoc}`);
        const loanDocs = result?.data?.data || [];
        setLoanDocs(flatMap(loanDocs));
    };

    const getRankFromLoanState = (loanEvent) => {
        const mapping = {
            'cibil': 0,
            'fi': 1,
            'do': 2,
            'file_check': 3,
            'pdd': 4,
            'disbursed': 5,
            'payment': 6
        };
        return mapping[loanEvent] || 0;
    };

    // Renders
    const HEADERS = ['Cibil ', 'FI ', 'Delivery Order ', 'File Check', 'Pdd', 'Disbursement', 'Payment'];

    const GridText = ({ header = '', value = '', lg = 3 }) => {
        return (
            <Grid item xs={12} md={6} lg={lg}>
                <Stack direction="row" spacing={1}>
                    <Typography fontWeight="bold">{header}:</Typography>
                    <Typography color="#5c5c5c">{value || '---'}</Typography>
                </Stack>
            </Grid>
        )
    }

    const BasicDetails = ({ loanDetails }) => {
        return (
            <Card sx={{ p: 3, mb: 2 }}>
                <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
                    <Typography sx={{ color: '#5c5c5c' }} variant="h5" gutterBottom>
                        Loan Details - {loanDetails?.loan_id} - {loanDetails?.type}
                    </Typography>
                </Stack>

                <Grid container spacing={2}>
                    <GridText header={'Name'} value={loanDetails?.customer_name} lg={4} />
                    <GridText header={'Mobile'} value={loanDetails?.mobile} lg={4} />
                    <GridText header={'Loan Type'} value={loanDetails?.type} lg={4} />
                    <GridText header={'OEM'} value={loanDetails?.oem_name} lg={4} />
                    <GridText header={'Loan Amount'} value={`INR ${new Intl.NumberFormat('en-IN').format(loanDetails?.sanctioned_amount || loanDetails?.amount)} /-`} lg={4} />
                </Grid>
            </Card>
        );
    };

    const ExtraDetails = ({ loanDetails }) => {
        return (
            <Card sx={{ p: 3, mb: 2 }}>
                <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
                    <Typography sx={{ color: '#5c5c5c' }} variant="h5" gutterBottom>
                        Loan Emi Details
                    </Typography>
                </Stack>
                <Grid container spacing={2}>
                    <GridText header={'Emi Start Date'} value={moment(loanDetails?.first_emi_date).format('DD-MM-YYYY')} lg={3} />
                    <GridText header={'Emi Day'} value={`${moment(loanDetails.first_emi_date).format('DD')} of Every Month`} lg={3} />
                    <GridText header={'Emi'} value={loanDetails?.emi} lg={3} />
                    <GridText header={'Tenure'} value={loanDetails?.tenure} lg={3} />
                    <GridText header={'No. of Emi Due'} value={loanDetails?.no_of_emi_due} lg={3} />
                    <GridText header={'Net Emi Due'} value={`INR ${new Intl.NumberFormat('en-IN').format(loanDetails?.net_emi_due)} /-`} lg={3} />
                    <GridText header={'Net Due'} value={`INR ${new Intl.NumberFormat('en-IN').format(loanDetails?.net_due)} /-`} lg={3} />
                </Grid>
            </Card>
        );
    };

    const PaymentDetails = ({ paymentDetail }) => {
        return (
            <Card sx={{ p: 3, mb: 2 }}>
                <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
                    <Typography sx={{ color: '#5c5c5c' }} variant="h5" gutterBottom>
                        Dealer Payment
                    </Typography>
                </Stack>

                {paymentDetail && paymentDetail?.map((payment, index) => (
                    <Grid container spacing={2} key={index} sx={{ mb: 1 }}>
                        <GridText header={'Amount'} value={`INR ${new Intl.NumberFormat('en-IN').format(payment?.amount)} /-`} />
                        <GridText header={'Payment Ref No'} value={payment?.payment_ref_no} />
                        <GridText header={'Payment Date'} value={payment?.ledger_date} />
                        <GridText header={'Payment Type'} value={payment?.payment_type?.toUpperCase()} />
                    </Grid>
                ))}
            </Card>
        );
    };

   const Deviation = ({ loanDeviation, loanDocs, loanDetails, fetchPddDetails }) => {
    const uploadFileBody = {
        customer_id: loanDetails.customer_id,
        loan_id: loanDetails.loan_id,
        relation_id: 0,
        doc_name: loanDetails?.customer_name
    };

    const customerId = loanDetails.customer_id;

    return (
        <Card sx={{ p: 3, mb: 2 }}>
            <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
                <Typography sx={{ color: '#5c5c5c' }} variant="h5" gutterBottom>
                    PDD Details - (Remaining {loanDeviation.length})
                </Typography>
            </Stack>

            {/* Table Header */}
            <Grid container spacing={2} sx={{ fontWeight: 'bold', borderBottom: '2px solid lightgrey', pb: 1, mb: 1 }}>
                <Grid item xs={1}>S.No</Grid>
                <Grid item xs={4}>Code</Grid>
                <Grid item xs={4}>Remarks</Grid>
                {allowedToUpload && <Grid item xs={3}>Document</Grid>}
            </Grid>

            {/* Table Rows */}
            {loanDeviation?.map((deviation, index) => {
                // Check if document already exists with relation_id = 0
                const uploadedDoc = loanDocs?.some(
                    doc => doc.doc_type === deviation.doc_type && doc.relation_id === 0
                );

                return (
                    <Grid
                        container
                        spacing={2}
                        key={index}
                        sx={{
                            mb: 1,
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0',
                            py: 1,
                        }}
                    >
                        <Grid item xs={1}>{index + 1}</Grid>
                        <Grid item xs={4}>{deviation?.code || '-'}</Grid>
                        <Grid item xs={4}>{deviation?.remarks || '-'}</Grid>
                        {allowedToUpload && <Grid item xs={3}>
                            {deviation.doc_type && (
                                uploadedDoc ? (
                                    // Pending Review Indicator
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <Box
                                            sx={{
                                                width: 12,
                                                height: 12,
                                                borderRadius: '50%',
                                                bgcolor: 'orange',
                                                animation: 'pulse 1.5s infinite',
                                            }}
                                        />
                                        <Typography sx={{ color: 'orange' }}>Pending Review</Typography>
                                    </Stack>
                                ) : (
                                    // Show file upload if document not present
                                    <FileStatus
                                        label={deviation.doc_type?.toUpperCase().replaceAll('_', ' ')}
                                        fileType={deviation.doc_type}
                                        details={uploadFileBody}
                                        onSuccess={() => fetchPddDetails(customerId)}
                                    />
                                )
                            )}
                        </Grid>}
                    </Grid>
                );
            })}

            {/* Pulse animation keyframes */}
            <style>
                {`
                    @keyframes pulse {
                        0% { transform: scale(0.8); opacity: 0.7; }
                        50% { transform: scale(1.2); opacity: 1; }
                        100% { transform: scale(0.8); opacity: 0.7; }
                    }
                `}
            </style>
        </Card>
    );
};


    return (
        <div style={{ margin: '10px', width: '90%', display: 'flex', gap: 10, flexDirection: 'column' }}>
            <StepProgressBar rank={rank} headers={HEADERS} />
            <BasicDetails loanDetails={loanDetails} />
            {rank > 3 && <ExtraDetails loanDetails={loanDetails} />}
            {rank > 5 && <PaymentDetails paymentDetail={dealerPaymentDetails} />}
            {rank === 4 && <Deviation
                    loanDeviation={loanDeviation}      
                    loanDocs={loanDoc}                 
                    loanDetails={loanDetails}           
                    fetchPddDetails={fetchPddDetails}   
                />}
        </div>
    );
}
